import * as React from 'react';
import s from '../PlansPage.scss';
import { Trans } from 'react-i18next';
import { Box, Text } from 'wix-style-react';
import { PlanType } from 'enums';

export interface CustomersPaymentBannerProps {
  action(planType: PlanType): void;
}

const CustomersPaymentBannerComp: React.FC<CustomersPaymentBannerProps> = ({
  action,
}) => {
  const translationTags = {
    1: (
      <span
        data-testid='customers-payment-banner-button'
        className={s.customersPaymentBannerTextLink}
        onClick={() => action(PlanType.Business)}
      />
    ),
  };
  return (
    <Box
      minHeight='48px'
      width='100%'
      verticalAlign='middle'
      align='center'
      marginBottom='30px'
      marginTop='-36px'
    >
      <Box gap='3px'>
        <div className={s.customersPaymentBannerIcon} />
        <Text
          dataHook='customers-payment-banner'
          className={s.customersPaymentBannerText}
        >
          <span>
            <Trans
              i18nKey='Advanced.Features_Marketing_Business_plans_new_banner'
              components={translationTags}
            ></Trans>
          </span>
        </Text>
      </Box>
    </Box>
  );
};

export const CustomersPaymentBanner = CustomersPaymentBannerComp;
